import React from 'react';
import { IonToolbar, IonButtons, IonHeader, IonTitle, IonBackButton } from '@ionic/react';
import { SlideDown } from 'react-slidedown';
import { NotificationsButton } from './Notifications';
import fork from '../assets/compeat/fork_transparent.png';
import { arrowBackOutline } from 'ionicons/icons';
import { useModal } from '../context/ModalProvider';
import { useUser } from '../context/UserProvider';
import { useProfile } from '../context/ProfileProvider';
import { useNetwork } from '../context/NetworkProvider';
import 'react-slidedown/lib/slidedown.css';
import './Header.scss';

export interface BannerProps {
  text: string;
  color: string;
}

const Header = (props: { banner?: BannerProps | null; buttons?: any; children?: any; showBackButton?: boolean; }) => {
  const { isConnected } = useNetwork();
  const { setShowNotification } = useModal();
  const { user } = useUser();
  const { profile } = useProfile();

  return (
    <IonHeader>
      <IonToolbar className="dashboard-toolbar">
        {props.showBackButton &&
          <IonButtons slot="start">
            <IonBackButton
              text=""
              icon={arrowBackOutline}
              className='px-2 back-button'
            />
          </IonButtons>
        }
        {props.children || <IonTitle>
          <img
            src={fork}
            width="44"
            height="44"
            alt="Compeat fork"
          />
        </IonTitle>}
        <IonButtons slot="primary">
          {props.buttons || (user?.id === profile?.id && <NotificationsButton handleOpen={() => setShowNotification(true)} />)}
        </IonButtons>
      </IonToolbar>
      <SlideDown>
        {!isConnected && <div className={`text-center bg-dark text-white`}>No Internet Connection</div>}
        {props.banner && <div className={`text-center bg-${props.banner.color} text-white`}>{props.banner.text}</div>}
      </SlideDown>
    </IonHeader>
  );
};

export default Header;

